import { computed } from 'vue';
import { fetchCurrentTenant, fetchCurrentTenantOwnersAndAdmins } from '@/api/resources/tenant.api';
import { useQueryWithToast } from '@/composables/useQueryWithToast';
import { useAuthStore } from '@/stores/useAuthStore';
import { useWhoAmIStore } from '@/stores/useWhoAmIStore';
import { currentTenantKeys } from './currentTenant.keys';

export const useCurrentTenantQuery = () => {
  const authStore = useAuthStore();
  const whoAmIStore = useWhoAmIStore();
  const tenantId = computed(() => whoAmIStore.whoAmI?.currentTenantId ?? null);
  const enabled = computed(() => authStore.csrfToken != null && tenantId.value != null);
  const query = useQueryWithToast({
    queryKey: computed(() => currentTenantKeys.detail(tenantId.value)),
    queryFn: fetchCurrentTenant,
    enabled,
  });

  const currentTenant = computed(() => {
    if (!enabled.value || query.data.value?.id !== tenantId.value) return null;
    return query.data.value;
  });
  const ownersAndAdminsQuery = useQueryWithToast({
    queryKey: computed(() => [...currentTenantKeys.ownersAndAdmins, tenantId.value]),
    queryFn: fetchCurrentTenantOwnersAndAdmins,
    enabled: computed(() => currentTenant.value != null),
  });

  return {
    currentTenant,
    currentTenantOwnersAndAdmins: computed(() => (currentTenant.value ? (ownersAndAdminsQuery.data.value ?? []) : [])),
    isCurrentTenantPending: computed(() => enabled.value && query.isPending.value),
  };
};
